<template>
  <el-dialog :title="$t('productGroupManage.edit')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item :label="$t('productGroupManage.productDesc')">
        <el-input v-model="form.prodDesc" type="textarea"
          :placeholder="$t('productGroupManage.productDescRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.groupPeople')">
        <el-input v-model="form.userCount" type="number"
          :placeholder="$t('productGroupManage.groupPeopleRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.groupPrice')">
        <el-input v-model="form.groupPrice"
          :placeholder="$t('productGroupManage.groupPriceRequired')" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.status')">
        <el-select v-model="form.state" :placeholder="$t('productGroupManage.statusRequired')"
          style="width:100%">
          <el-option disabled :value="''" :label="$t('productGroupManage.statusRequired')" />
          <el-option :label="$t('productGroupManage.enable')" value="1001" />
          <el-option :label="$t('productGroupManage.disable')" value="2002" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.startTime')">
        <el-date-picker v-model="form.startTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('productGroupManage.startTimeRequired')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.endTime')">
        <el-date-picker v-model="form.endTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('productGroupManage.endTimeRequired')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('productGroupManage.isRebate')">
        <el-select v-model="form.rebateFlag" :placeholder="$t('productGroupManage.isRebateRequired')"
          style="width:100%">
          <el-option disabled :value="''" :label="$t('productGroupManage.isRebateRequired')" />
          <el-option :label="$t('productGroupManage.yes')" value="Y" />
          <el-option :label="$t('productGroupManage.no')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="form.rebateFlag === 'Y'" :label="$t('productGroupManage.leaderRebate')">
        <el-row :gutter="20">
          <el-col :span="4">
            <span>{{ $t('productGroupManage.commercialPrice') }}</span>
          </el-col>
          <el-col :span="4">
            <el-input v-model="form.rebate" type="number"
              :placeholder="$t('productGroupManage.rebateNumber')" />
          </el-col>
          <el-col :span="4">
            <span>% {{ $t('productGroupManage.rebate') }}</span>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editProductGroup">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateProductGroup } from '@/api/group/productGroupApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditProductGroup',
  data() {
    return {
      dialogVisible: false,
      form: {
        groupId: '',
        prodName: '',
        productId: '',
        valueId: '',
        prodDesc: '',
        userCount: '',
        groupPrice: '',
        state: '',
        startTime: '',
        endTime: '',
        rebateFlag: '',
        rebate: ''
      }
    }
  },
  methods: {
    open(row) {
      console.log(row)
      this.dialogVisible = true
      // 使用 $nextTick 确保组件渲染完成后再设置值
      this.$nextTick(() => {
        // 确保日期格式正确，处理可能的格式问题
        this.form = {
          ...row,
          startTime: this._formatDateTime(row.startTime),
          endTime: this._formatDateTime(row.endTime)
        }
      })
    },
    _formatDateTime(dateTime) {
      if (!dateTime) return ''
      // 如果是字符串，确保格式正确
      if (typeof dateTime === 'string') {
        // 处理 ISO 格式 (2024-01-01T00:00:00 或 2024-01-01T00:00:00.000Z)
        if (dateTime.includes('T')) {
          const formatted = dateTime.replace('T', ' ').replace(/\.\d{3}Z?$/, '').substring(0, 19)
          return formatted
        }
        // 如果已经是正确格式，直接返回
        if (dateTime.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
          return dateTime
        }
        // 如果只有日期部分，添加时间
        if (dateTime.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return dateTime + ' 00:00:00'
        }
      }
      return dateTime || ''
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = {
        groupId: '',
        prodName: '',
        productId: '',
        valueId: '',
        prodDesc: '',
        userCount: '',
        groupPrice: '',
        state: '',
        startTime: '',
        endTime: '',
        rebateFlag: '',
        rebate: ''
      }
    },
    async editProductGroup() {
      try {
        this.form.shopId = getShopId()
        await updateProductGroup(this.form)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>